import { Suspense } from 'react'
import { Routes, Route } from 'react-router-dom';
import { DynamicPages } from '../lib/dynamic-pages'
import { LoadingFallback } from './ui/loading-fallback'
import { ProtectedRoute } from './protected-route'

export function AppRoutes() {
  return (
		<Suspense fallback={<LoadingFallback className='h-96' />}>
			<Routes>
				<Route
					path='/'
					element={<DynamicPages.Home />}
				/>
				<Route
					path='/como-se-faz'
					element={<DynamicPages.ComoSeFaz />}
				/>
				<Route
					path='/auth/*'
					element={<DynamicPages.Auth />}
				/>
				<Route 
          path="/painel" 
          element={
            <ProtectedRoute>
              <DynamicPages.Dashboard />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/relatorios" 
          element={
            <ProtectedRoute>
              <DynamicPages.Reports />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/relatorios/criar" 
          element={
            <ProtectedRoute>
              <DynamicPages.CreateReport />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/relatorios/editar/:id" 
          element={
            <ProtectedRoute>
              <DynamicPages.EditReport />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/projetos" 
          element={
            <ProtectedRoute>
              <DynamicPages.Projects />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/projetos/criar" 
          element={
            <ProtectedRoute>
              <DynamicPages.CreateProject />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/projetos/editar/:id" 
          element={
            <ProtectedRoute>
              <DynamicPages.EditProject />
            </ProtectedRoute>
          } 
        />
        {/* Deprecated routes - redirect to Portuguese equivalents */}
        <Route 
          path="/reports" 
          element={
            <ProtectedRoute>
              <DynamicPages.Reports />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/reports/criar" 
          element={
            <ProtectedRoute>
              <DynamicPages.CreateReport />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/reports/edit/:id" 
          element={
            <ProtectedRoute>
              <DynamicPages.EditReport />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/carteira" 
          element={
            <ProtectedRoute>
              <DynamicPages.Wallet />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/conta" 
          element={
            <ProtectedRoute>
              <DynamicPages.Account />
            </ProtectedRoute>
          } 
        />
			</Routes>
		</Suspense>
	);
}